import { render, staticRenderFns } from "./Extend-Billing.vue?vue&type=template&id=298e36d1&scoped=true"
import script from "./Extend-Billing.vue?vue&type=script&lang=js"
export * from "./Extend-Billing.vue?vue&type=script&lang=js"
import style0 from "./Extend-Billing.vue?vue&type=style&index=0&id=298e36d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298e36d1",
  null
  
)

export default component.exports